module.exports = __webpack_public_path__ + "static/media/002_UX_adoption_cycle.acd271b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/vmware/002_UX_adoption_cycle.png
// module id = 635
// module chunks = 0